export const objectDifference = <
  T extends Record<string, string | boolean | number | null | undefined>,
>(
  a: T,
  b: T,
) =>
  Object.fromEntries(
    Object.entries(b).filter(([key, val]) => key in a && a[key] !== val),
  );
